import { useContext, useEffect, useReducer, useState } from "react"
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion"
import { Get, Post2, PostSinContent } from "../Rutas/ApiRest"
import { Carga, VendemosContigo, cuentaCliente } from "../Rutas/Servicios"
import { tokens } from "../Context/Tokens"
import { Contexto } from "../Context/Contexto"
import { NotificacionesGeneral } from "../Context/Notificaciones_Context"
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext"
import { MensajeEliminarPreAlerta, Modelos } from "../Paginas/Modelos"

export default function SoloPreAlertaVendemosContigo(dato:any)
{
    const {tok}=useContext(tokens)
    const {Cli}=useContext(Contexto)
    const {SetMensajeEmergente,SetLoading,SetId,Id,SetId2,Id2}=useContext(MensajeContActualizacion)
    const [states,dispatch]=useReducer(reducer,{nombre:dato.contenido[3].value,direccion:dato.contenido[6].value,envio:dato.contenido[5].value,preparacion:dato.contenido[4].value,telefono:dato.contenido[7].value})
    const {GuiaBusquedaPreAlerta}=useContext(GuiaBusquedaCont)
    const [Activo,SetActivo]=useState(true)
    var collapseId="flush-collapse"+dato.id;
    var idHeading="flush-heading"+dato.id;
    var guias:any=[]
    function cambio(event:any)
    {

        dispatch({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
    }
    function reducer(state:any,action:any)
    {
      switch(action.type)
      {
        
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":
          {
            
            return {nombre:dato.contenido[3].value,direccion:dato.contenido[6].value,envio:dato.contenido[5].value,preparacion:dato.contenido[4].value,telefono:dato.contenido[7].value}
        }
          
         
      }
    
      return state;
    }

    useEffect(()=>
    {
        SetActivo(true)
        dispatch({type:"Reinicio"})
    },[dato])

    useEffect(()=>
    {
        if(states.nombre.length<=2 || states.direccion.length<=2 || states.envio.length<=2 || states.preparacion.length<=2 || states.telefono.length<=2)
        {
            SetActivo(false)
        }else
        {
            SetActivo(true)
        }
    },[states])

    const aceptar=()=>
    {
        if(confirmar())
        {
            var body=
            {
                "id" : dato.guia,
                "nombre":states.nombre,
                "direccion":states.direccion,
                "preparacion":states.preparacion,
                "envio":states.envio,
                "telefono":states.telefono,
                "TotalGuias":guias,
            }

            const dato3=Post2(VendemosContigo.EditarPreAlerta,JSON.stringify(body),"application/json",tok)
             dato3?.then(resultado=>{SetMensajeEmergente(resultado);SetLoading(false)})
            
        }
        SetLoading(false)
    
    }

    

    const confirmar=()=>
    {
        SetLoading(true)

        return true;
    }


    return(
        <>
        <div className="accordion-item" key={dato.guia} >
                            <h2 className="accordion-header" id={idHeading}>
                                <button className={GuiaBusquedaPreAlerta==dato.guia?"accordion-button":"accordion-button collapsed"}   type="button" data-bs-toggle="collapse" data-bs-target={"#"+collapseId} aria-expanded={GuiaBusquedaPreAlerta==dato.guia?"true":"false"}  aria-controls={collapseId}>PreAlerta con despacho a  {dato.contenido[6].value} </button>
                            </h2>
                            <div id={collapseId} className={GuiaBusquedaPreAlerta==dato.guia?"accordion-collapse collapse show":"accordion-collapse collapse"}  aria-labelledby={idHeading} >
                                <div className="card-body">
                                    <h5>Guias asociadas : {dato.contenido[1].value}</h5>
                                    <h6>Descripcion : {dato.contenido[2].value}</h6>
          <div className="row pt-1 pt-sm-3">
              <div className="col-12 col-sm-6">
                  <div className="mb-3">
                  <label className="form-label">Nombre del destinatario</label>
                  <input className="col-12 col-m-8" name="nombre" value={states.nombre} onChange={cambio} ></input>
                  </div>
                  <div className="mb-3">
                  <label className="form-label">Direccion destino</label>
                  <input className="col-12 col-m-8" name="direccion" value={states.direccion} placeholder="Padre Hurtado central 1531, Local 1,Las Condes, Santiago" onChange={cambio}></input>
                  <p className="small py-1">ej: Padre Hurtado central 1531, Local 1,Las Condes, Santiago</p>
                  </div>
                  <div className="mb-3">
                  <label className="form-label">Telefono destinatario</label>
                  <input className="col-12 col-m-8" name="telefono" value={states.telefono} placeholder="Padre Hurtado central 1531, Local 1,Las Condes, Santiago" onChange={cambio}></input>
                  </div>
                  <div className="mb-3">
                  <label className="form-label">Especificacion de preparacion</label>
                  <textarea className="col-12 col-m-8" name="preparacion" value={states.preparacion} onChange={cambio}></textarea>
                  <p className="small py-1">caja, sobre, paquete</p>
                  </div>
                  <div className="mb-3">
                  <label className="form-label">Especificacion de envio</label>
                  <textarea className="col-12 col-m-8" name="envio" value={states.envio} onChange={cambio}></textarea>
                  <p className="small py-1">2 poleras Xl rojas, 1 pantalon azul</p>
                  </div>
                  <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-4 my-1 px-sm-2">
                        <input type="button" className="btn btn-success" id="enviarFactura" value="Modificar PreAlerta" onClick={()=>{SetLoading(true);aceptar();}} disabled={!Activo}/>
                        </div>
                        <div className="col-sm-4 my-1 px-sm-2">
                        <input type="button" className="btn btn-danger" id="enviarFactura" value="Eliminar PreAlerta" onClick={()=>{SetId(dato.guia);}} />
                        </div>
                       
                    </div> 

            
            
                </div>
                  <div className="col-auto">
                      
                      
                  </div>
              </div>
          </div>
                                    
                                    
                                </div>
                            </div>
                            </div>  
               <MensajeEliminarPreAlerta></MensajeEliminarPreAlerta>       
        </>
    )
}